import { render, staticRenderFns } from "./MobileFloatings.vue?vue&type=template&id=38c72acf&scoped=true&"
import script from "./MobileFloatings.vue?vue&type=script&lang=js&"
export * from "./MobileFloatings.vue?vue&type=script&lang=js&"
import style0 from "./MobileFloatings.vue?vue&type=style&index=0&id=38c72acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c72acf",
  null
  
)

export default component.exports